import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import partnerPaperTheme from "../../crosscutting/themes/partnerPaperTheme";
import partnerLiveTheme from "../../crosscutting/themes/partnerLiveTheme";
import { useAppState } from "./contextProvider";

export const AppThemeProvider = ({ children }) => {
  const { theme } = useAppState();
  const themeMode = theme?.mode || "PT";
  const currentTheme = themeMode === "PT" ? partnerPaperTheme : partnerLiveTheme;

  return <ThemeProvider theme={currentTheme}>{children}</ThemeProvider>;
};
